import {gql} from 'apollo-boost'

export * from './contractDetail';

export const IMPORT_CONTRACTS = gql`
  mutation importContracts($meta: MetaImportInput!, $payload: [ImportContractsInput]) {
    importContracts(
      meta: $meta
      payload: $payload
    ){
      success
      error
      errorMassage
    }
  }
`

export const IMPORT_LOAN_DETAILS = gql`
  mutation importLoanDetails($meta: MetaImportInput!, $payload: [ImportLoanDetailsInput]) {
    importLoanDetails(
      meta: $meta
      payload: $payload
    ){
      success
      error
      errorMassage
    }
  }
`

export const IMPORT_LOAN_DETAIL_PLANS = gql`
  mutation importLoanDetailPlans($meta: MetaImportInput!, $payload: [ImportLoanDetailsInput]) {
    importLoanDetailPlans(
      meta: $meta
      payload: $payload
    ){
      success
      error
      errorMassage
    }
  }
`

export const IMPORT_PAYMENTS = gql`
  mutation importPayments($meta: MetaImportInput!, $payload: [ImportPaymentsInput]) {
    importPayments(
      meta: $meta
      payload: $payload
    ){
      success
      error
      errorMassage
    }
  }
`

export const IMPORT_TRACK_DOWN_DEBTS = gql`
  mutation importTrackDownDebts($meta: MetaImportInput!, $payload: [ImportTrackDownDebtsInput]) {
    importTrackDownDebts(
      meta: $meta
      payload: $payload
    ){
      success
      error
      errorMassage
    }
  }
`

export const IMPORT_CONTRACT_SURETIES = gql`
  mutation importContractsSureties($meta: MetaImportInput!, $payload: [ImportContractsInput]) {
    importContractsSureties(
      meta: $meta
      payload: $payload
    ){
      success
      error
      errorMassage
    }
  }
`

export const IMPORT_BAD_DEBTS = gql`
  mutation importBadDebts($meta: MetaImportInput!, $payload: [ImportBadDebtsInput]) {
    importBadDebts(
      meta: $meta
      payload: $payload
    ){
      success
      error
      errorMassage
    }
  }
`

export const GET_CONTRACT_NO = gql`
  query getContractNo ($borrowerId: ID!){
    getContractNo(
      borrowerId: $borrowerId
    ){
      contractNo
    }
  }
`

export const GET_CONTRACT = gql`
  query getContract($id: ID!) {
    getContract(
      id: $id
    ) {
      id
      contractSeq
      contractNo
      accoNo
      contractName
      contractDate
      contractLoanDate
      registrationFee
      loanRegistrationFee
      paidRegistrationFee

      contractFee
      taxAmount
      processingFee
      courtOrderExpense

      periodTermStart
      periodYearStart
      periodTermEnd
      periodYearEnd
      contractAmount
      contractAmountText
      contractStatus
      educationStatus
      educationStatusName
      educationStatusExternal
      educationStatusExternalName
      forecastDate
      graduationDate
      restructuring
      restructuringType
      createdWith
      tempReceiptUrl
      status
      borrower{
        id
        prefix{
          id
          nameTh
        }
        name
        surname
        birthDay
        idCardNumber
        studentCode
        issueDate
        expDate
        nationality{
          id
          nameTh
        }
        race{
          id
          nameTh
        }
        address{
          location
          houseNumber
          moo
          alley
          road
          subDistrict
          district
          province
          zipcode
          locationDoc
          houseNumberDoc
          mooDoc
          alleyDoc
          roadDoc
          subDistrictDoc
          districtDoc
          provinceDoc
          zipcodeDoc
        }
        curriculum{
          id
          curriculumNo
          nameTh
        }
        period{
          id
          term
          year
          name
        }
        educationStatus
        project{
          id
          nameTh
        }
        phone
        mobile
        email
      }
      suretyDetails{
        id
        seq
        relationshipId
        relationshipName
        status
        surety{
          id
          prefix{
            id
            nameTh
          }
          name
          surname
          birthDay
          idCardNumber
          issueDate
          expDate
          nationality{
            id
            nameTh
          }
          race{
            id
            nameTh
          }
          address{
            location
            houseNumber
            moo
            alley
            road
            subDistrict
            district
            province
            zipcode
            locationDoc
            houseNumberDoc
            mooDoc
            alleyDoc
            roadDoc
            subDistrictDoc
            districtDoc
            provinceDoc
            zipcodeDoc
          }
          occupation{
            id
            nameTh
          }
          position
          affiliate
          phone
          mobile
          email
        }
      }
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
      }
      periods{
        id
        term
        year
        name
      }
      loan{
        id
        loanType
        loanTypeName
        interestType
        interestRate
        penaltyType
        penaltyRate
        interestRateEir
        debtCollectionFeeType
        debtCollectionFeeTypeName
        period
        paymentDue
        paymentDescription
        loanAmount
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
        lastUpdate
        interestRateDetails{
          id
          seq
          interestDate
          interestType
          interestRate
          penaltyType
          penaltyRate
          debtCollectionFeeType
          debtCollectionFeeTypeName
          remark
          status
        }
        loanDetails{
          id
          adjustment
          loanDetailType
          transaction{
            id
          }
          loanDate
          seq
          amount
        }
        loanDetailPlans{
          id
          seq
          loanDetailType
          loanDate
          amount
        }
        feeDetails{
          id
          adjustment
          transaction{
            id
          }
          feeType
          feeDate
          seq
          amount
          remark
          status
        }
        paymentRounds{
          id
          paymentRoundDate
          paymentRoundSeq
          paymentRoundType
          paymentRoundAmount
          paymentRoundAmountRestructuring
          paymentRoundInterestFixed
          paymentRoundInterest
          paymentRoundBalance
          paymentRoundRemark
          paymentRoundExtra
          transactionCount
        }
        payments{
          id
          adjustment
          transaction{
            id
            paidAccruedFee
            paidAccruedPenalty
            paidAccruedInterest
            paidPrinciple
            balanceRemain
            paymentRound{
              id
              paymentRoundSeq
              paymentRoundType
              paymentRoundDate
            }
          }
          qrPayment{
            type
          }
          paymentType
          receiveDate
          paymentDate
          paymentAmount
          paymentPrinciple
          paymentRemark
          createdAt
          createdBy{
            id
            prefix{
              id
              nameTh
            }
            name
            surname
            username
          }
        }
      }
      contractStatusTransactions{
        id
        contractStatus
        remark
        createdAt
        createdBy{
          id
          email
        }
      }
      files{
        id
        seq
        contract{
          id
        }
        description
        fileName
        fileType
        pathUrl
        status
        createdAt
        updatedAt
        createdBy{
          id
        }
        updatedBy{
          id
        }
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
        remark
      }
      restructuringReference{
        id
      }
      callHistories{
        id
        seq
        callDate
        remark
        status
      }
      callHistoriesReceivedStatus
      callHistoriesReceivedAt
      callHistoriesReceivedBy{
        id
        prefix{
          id
          nameTh
        }
        name
        surname
        username
      }
      sendSmsHistories{
        id
        seq
        sendDate
        remark
        status
      }
      sendDocHistories{
        id
        seq
        sendDate
        remark
        status
      }
      lawsuitHistories{
        id
        seq
        lawsuitDate
        remark
        status
      }
    }
  }
`

export const GET_CONTRACT_TRANSACTION_MANAGE = gql`
  query getContract($id: ID!) {
    getContract(
      id: $id
    ) {
      id
      contractSeq
      contractNo
      accoNo
      contractName
      contractDate
      contractLoanDate
      registrationFee
      loanRegistrationFee
      paidRegistrationFee

      contractFee
      taxAmount
      processingFee
      courtOrderExpense

      periodTermStart
      periodYearStart
      periodTermEnd
      periodYearEnd
      contractAmount
      contractAmountText
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
      }
      periods{
        id
        term
        year
        name
      }
      loan{
        id
        loanType
        loanTypeName
        interestType
        interestRate
        penaltyType
        penaltyRate
        interestRateEir
        period
        paymentDue
        paymentDescription
        loanAmount
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
        lastUpdate
        interestRateDetails{
          id
          seq
          interestDate
          interestType
          interestRate
          penaltyType
          penaltyRate
          remark
          status
        }
        loanDetails{
          id
          adjustment
          loanDetailType
          transaction{
            id
          }
          loanDate
          seq
          amount
        }
        loanDetailPlans{
          id
          seq
          loanDetailType
          loanDate
          amount
        }
        feeDetails{
          id
          adjustment
          transaction{
            id
          }
          feeType
          feeDate
          seq
          amount
          remark
          status
        }
        paymentRounds{
          id
          paymentRoundDate
          paymentRoundSeq
          paymentRoundType
          paymentRoundAmount
          paymentRoundAmountRestructuring
          paymentRoundInterestFixed
          paymentRoundInterest
          paymentRoundBalance
          paymentRoundRemark
          paymentRoundExtra
          transactionCount
        }
        payments{
          id
          adjustment
          transaction{
            id
            paidAccruedFee
            paidAccruedPenalty
            paidAccruedInterest
            paidPrinciple
            balanceRemain
            paymentRound{
              id
              paymentRoundSeq
              paymentRoundType
              paymentRoundDate
            }
          }
          qrPayment{
            type
          }
          paymentType
          receiveDate
          paymentDate
          paymentAmount
          paymentPrinciple
          paymentRemark
          createdAt
          createdBy{
            id
            prefix{
              id
              nameTh
            }
            name
            surname
            username
          }
        }
      }
      educationStatus
      educationStatusName
      educationStatusExternal
      educationStatusExternalName
      forecastDate
      graduationDate
      contractStatusTransactions{
        id
        contractStatus
        remark
        createdAt
        createdBy{
          id
          email
        }
      }
      contractStatus
      restructuring
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
        remark
      }
      restructuringReference{
        id
      }
      callHistories{
        id
        seq
        callDate
        remark
        status
      }
      callHistoriesReceivedStatus
      callHistoriesReceivedAt
      callHistoriesReceivedBy{
        id
        prefix{
          id
          nameTh
        }
        name
        surname
        username
      }
      sendSmsHistories{
        id
        seq
        sendDate
        remark
        status
      }
      sendDocHistories{
        id
        seq
        sendDate
        remark
        status
      }
      lawsuitHistories{
        id
        seq
        lawsuitDate
        remark
        status
      }
      createdWith
      tempReceiptUrl
      status
    }
  }
`

export const GET_CONTRACT_PAYMENTS = gql`
  query getContractPayments($id: ID!) {
    getContract(
      id: $id
    ) {
      id
      loan{
        id
        payments{
          id
          adjustment
          transaction{
            id
            paidAccruedFee
            paidAccruedPenalty
            paidAccruedInterest
            paidPrinciple
            balanceRemain
            paymentRound{
              id
              paymentRoundSeq
              paymentRoundType
              paymentRoundDate
            }
          }
          qrPayment{
            type
          }
          paymentType
          receiveDate
          paymentDate
          paymentAmount
          paymentPrinciple
          paymentRemark
          createdAt
          createdBy{
            id
            prefix{
              id
              nameTh
            }
            name
            surname
            username
          }
        }
      }
    }
  }
`

export const GET_CONTRACT_EDIT = gql`
  query getContract($id: ID!) {
    getContract(
      id: $id
    ) {
      id
      contractSeq
      contractNo
      accoNo
      contractName
      contractDate
      contractLoanDate
      registrationFee
      loanRegistrationFee
      paidRegistrationFee

      contractFee
      taxAmount
      processingFee
      courtOrderExpense

      periodTermStart
      periodYearStart
      periodTermEnd
      periodYearEnd
      contractAmount
      contractAmountText
      contractStatus
      forecastDate
      graduationDate
      restructuring
      restructuringType
      createdWith
      status
      project{
        id
        nameTh
      }
      campus{
        id
        nameTh
      }
      borrower{
        id
        prefix{
          id
          nameTh
        }
        project{
          id
          nameTh
        }
        name
        surname
        idCardNumber
        studentCode
      }
      suretyDetails{
        id
        seq
        relationshipId
        status
        surety{
          id
          fullName
        }
      }
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
      }
      periodTermStart
      periodYearStart
      periodTermEnd
      periodYearEnd
      loan{
        id
        loanType
        loanTypeName
        interestType
        interestRate
        penaltyType
        penaltyRate
        interestRateEir
        debtCollectionFeeType
        period
        paymentDue
        paymentDescription
        loanAmount
        loanDetails{
          id
          adjustment
          loanDetailType
          transaction{
            id
          }
          loanDate
          seq
          amount
        }
        loanDetailPlans{
          id
          seq
          loanDetailType
          loanDate
          amount
        }
        paymentRounds{
          id
          paymentRoundDate
          paymentRoundSeq
          paymentRoundType
          paymentRoundAmount
          paymentRoundAmountRestructuring
          paymentRoundInterestFixed
          paymentRoundInterest
          paymentRoundBalance
          paymentRoundRemark
          paymentRoundExtra
          transactionCount
        },
        payments {
          id
          adjustment
          paymentType
          paymentDate
          paymentAmount
          paymentPrinciple
          paymentRemark
          qrPayment{
            type
          }
        }
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
        remark
      }
      restructuringReference{
        id
      }
      subMeasure{
        id
        orderNumber
        name
        description
      }
    }
  }
`

export const GET_CONTRACT_WITH_OUT_AUTH = gql`
  query getContractWithOutAuth($id: ID!, $token: String!) {
    getContractWithOutAuth(
      id: $id,
      token: $token,
    ){
      id
      contractSeq
      contractNo
      contractName
      contractDate
      contractAmount
      contractAmountText
      smartAppStatus
      contractStatus
      verifyToken
      status
      borrower{
        id
        genderName
        fullName
        fullAddress
        birthDay
        idCardNumber
        studentCode
        issueDate
        expDate
        address{
          location
          houseNumber
          moo
          alley
          road
          subDistrict
          district
          province
          zipcode
        }
        phone
        mobile
        email
        fileImageApproved{
          id
          description
          fileName
          fileType
          pathUrl
          status
          createdAt
          updatedAt
        }
        fileVideoApproved{
          id
          description
          fileName
          fileType
          pathUrl
          status
          createdAt
          updatedAt
        }
      }
    }
  }
`

export const GET_NOTIFICATION_CONTRACT_SMART_APP = gql`
  query getContract($id: ID!) {
    getContract(
      id: $id
    ) {
      id
      contractSeq
      contractNo
      contractName
      contractDate
      contractAmount
      contractAmountText
      smartAppStatus
      contractStatus
      verifyToken
      status
      borrower{
        id
        genderName
        fullName
        fullAddress
        birthDay
        idCardNumber
        studentCode
        issueDate
        expDate
        address{
          location
          houseNumber
          moo
          alley
          road
          subDistrict
          district
          province
          zipcode
        }
        phone
        mobile
        email
      }
      suretyDetails{
        id
        seq
        surety{
          id
          fullName
        }
      }
      curriculumExternal{
        id
        startDate
        graduationDate
        degreeName
        periodYear
        periodTerm
        facultyName
        curriculumName
        loanDetail{
          loanAmount
          loanAmountWithOutRegistrationFee
          interestPeriodDetail{
            startDate
            endDate
            periods
            amount
            amountWithOutRegistrationFee
          }
          principlePeriodDetail{
            startDate
            endDate
            periods
            amount
            amountWithOutRegistrationFee
          }
        }
      }
    }
  }
`

export const GET_CONTRACT_FILES = gql`
  query getContract($id: ID!) {
    getContract(
      id: $id
    ) {
      id
      contractSeq
      contractNo
      accoNo
      contractName
      contractDate
      contractStatus
      smartAppStatus
      files{
        id
        seq
        description
        fileName
        fileType
        pathUrl
        status
        fileCategory
        fileFrom
        createdAt
        updatedAt
        borrower{
          id
        }
        surety{
          id
        }
        createdBy{
          id
        }
        updatedBy{
          id
        }
      }
      loan{
        id
        loanType
      }
      createdWith
      status
    }
  }
`

export const GET_CONTRACTS = gql`
  query getContracts {
    getContracts{
      id
      contractSeq
      contractNo
      contractName
      contractDate
      contractAmount
      loan{
        id
        loanType
      }
      contractStatusTransactions{
        id
        contractStatus
        remark
        createdAt
        createdBy{
          id
          email
        }
      }
      contractStatus
      smartAppStatus
      smartAppStatusName
      createdWith
      actions{
        view
        visible
        create
        edit
        delete
      }
      status
    }
  }
`

export const GET_CONTRACTS_CREATED_BY_CURRENT_USER = gql`
  query getContractsCreatedByCurrentUser {
    getContractsCreatedByCurrentUser{
      id
      contractSeq
      contractNo
      contractName
      contractDate
      contractAmount
      loan{
        id
        loanType
      }
      contractStatusTransactions{
        id
        contractStatus
        remark
        createdAt
        createdBy{
          id
          email
        }
      }
      contractStatus
      smartAppStatus
      smartAppStatusName
      createdWith
      actions{
        view
        visible
        create
        edit
        delete
      }
      status
    }
  }
`

export const GET_CONTRACTS_PROCESS_LOCKED = gql`
  query getContractsProcessLocked {
    getContractsProcessLocked{
      id
      contractNo
      contractName
      loan {
        id
        processDate
        calculationLog {
          id
          date
          calculationLogDetails {
            id
            model
            action
            payload
            payloadData
            payloadBeforeData
            createdAt
          }
        }
      }
    }
  }
`

export const GET_CONTRACTS_BY_FILTERS = gql`
  query getContractsByFilters($payload: ContractFiltersInput) {
    getContractsByFilters(
      payload: $payload
    ){
      id
      contractSeq
      contractNo
      contractName
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
      }
      loan{
        id
        loanType
        loanTypeName
      }
      borrower{
        project{
          id
          nameTh
        }
      }
      contractStatus
      status
    }
  }
`

export const GET_CONTRACTS_TRACK_DOWN_DEBT_BY_FILTERS = gql`
  query getContractsTrackDownDebtByFilters($payload: ContractFiltersInput) {
    getContractsTrackDownDebtByFilters(
      payload: $payload
    ){
      id
      contractSeq
      contractNo
      contractName
      agingDate
      agingNumber
      contractAmount
      loanAmount
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      principleRemain
    }
  }
`

export const GET_CONTRACT_OPTIONS = gql`
  query getContractsByFilters($payload: ContractFiltersInput) {
    getContractsByFilters(
      payload: $payload
    ){
      id
      contractNo
      contractName
      status
    }
  }
`

export const GET_CONTRACT_OPTIONS_FOR_PROSECUTION = gql`
  query getContractsByFilters($payload: ContractFiltersInput) {
    getContractsByFilters(
      payload: $payload
    ){
      id
      contractSeq
      contractNo
      contractName
      contractDate
      restructuring
      status
      ## custom field
      curriculumName
      firstMissedAppointmentDate
    }
  }
`

export const CREATE_CONTRACT = gql`
  mutation createContract($payload: ContractInput) {
    createContract(
      payload: $payload
    ){
      id
    }
  }
`

export const UPDATE_CONTRACT = gql`
  mutation updateContract($id: ID!, $reCalculate: Boolean!, $payload: ContractInput!) {
    updateContract(
      id: $id,
      reCalculate: $reCalculate,
      payload: $payload
    ) {
      id
      contractSeq
      contractNo
      accoNo
      contractName
      contractDate
      contractLoanDate
      registrationFee
      loanRegistrationFee
      paidRegistrationFee

      contractFee
      taxAmount
      processingFee
      courtOrderExpense

      periodTermStart
      periodYearStart
      periodTermEnd
      periodYearEnd
      contractAmount
      contractAmountText
      contractStatus
      forecastDate
      graduationDate
      restructuring
      restructuringType
      createdWith
      status
      subMeasure{
        id
        orderNumber
        name
        description
      }
      project{
        id
        nameTh
      }
      campus{
        id
        nameTh
      }
      borrower{
        id
        prefix{
          id
          nameTh
        }
        project{
          id
          nameTh
        }
        name
        surname
        idCardNumber
        studentCode
      }
      suretyDetails{
        id
        seq
        relationshipId
        status
        surety{
          id
          fullName
        }
      }
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
      }
      periodTermStart
      periodYearStart
      periodTermEnd
      periodYearEnd
      loan{
        id
        loanType
        loanTypeName
        interestType
        interestRate
        penaltyType
        penaltyRate
        interestRateEir
        debtCollectionFeeType
        period
        paymentDue
        paymentDescription
        loanAmount
        loanDetails{
          id
          adjustment
          loanDetailType
          transaction{
            id
          }
          loanDate
          seq
          amount
        }
        loanDetailPlans{
          id
          seq
          loanDetailType
          loanDate
          amount
        }
        paymentRounds{
          id
          paymentRoundDate
          paymentRoundSeq
          paymentRoundType
          paymentRoundAmount
          paymentRoundAmountRestructuring
          paymentRoundInterestFixed
          paymentRoundInterest
          paymentRoundBalance
          paymentRoundRemark
          paymentRoundExtra
          transactionCount
        },
        payments {
          id
          adjustment
          paymentType
          paymentDate
          paymentAmount
          paymentPrinciple
          paymentRemark
          qrPayment{
            type
          }
        }
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
        remark
      }
      restructuringReference{
        id
      }
    }
  }
`

export const UPDATE_CONTRACT_STATUS = gql`
  mutation updateContractStatus($id: ID!, $payload: ContractStatusTransactionInput!) {
    updateContractStatus(
      id: $id
      payload: $payload
    ) {
      id
      contractSeq
      contractNo
      accoNo
      contractName
      contractDate
      contractLoanDate
      registrationFee

      contractFee
      taxAmount
      processingFee
      courtOrderExpense

      contractAmount
      contractAmountText
      forecastDate
      graduationDate
      contractStatus
      restructuring
      createdWith
      status
      project{
        id
        nameTh
      }
      borrower{
        id
        prefix{
          id
          nameTh
        }
        name
        surname
        idCardNumber
        studentCode
      }
      suretyDetails{
        id
        seq
        relationshipId
        relationshipName
        status
        surety{
          id
          prefix{
            id
            nameTh
          }
          name
          surname
          idCardNumber
        }
      }
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
      }
      periodTermStart
      periodYearStart
      periodTermEnd
      periodYearEnd
      loan{
        id
        loanType
        loanTypeName
        interestType
        interestRate
        penaltyType
        penaltyRate
        interestRateEir
        period
        paymentDue
        paymentDescription
        loanAmount
        loanDetails{
          id
          adjustment
          loanDetailType
          transaction{
            id
          }
          loanDate
          seq
          amount
        }
        loanDetailPlans{
          id
          seq
          loanDetailType
          loanDate
          amount
        }
        paymentRounds{
          id
          paymentRoundDate
          paymentRoundSeq
          paymentRoundType
          paymentRoundAmount
          paymentRoundInterestFixed
          paymentRoundInterest
          paymentRoundBalance
          paymentRoundRemark
          paymentRoundExtra
          transactionCount
        }
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
        remark
      }
      restructuringReference{
        id
      }
    }
  }
`

export const SET_EDUCATION_STATUS = gql`
  mutation setEducationStatus($contractId: ID!, $payload: SetEducationStatusInput!) {
    setEducationStatus(
      contractId: $contractId
      payload: $payload
    ) {
      id
      contractSeq
      contractNo
      contractName
      contractDate
      borrower{
        id
        prefix{
          id
          nameTh
        }
        name
        surname
        birthDay
        idCardNumber
        studentCode
        issueDate
        expDate
        nationality{
          id
          nameTh
        }
        race{
          id
          nameTh
        }
        curriculum{
          id
          curriculumNo
          nameTh
        }
        period{
          id
          term
          year
          name
        }
        educationStatus
        project{
          id
          nameTh
        }
        phone
        mobile
        email
      }
      contractAmount
      contractAmountText
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
      }
      periods{
        id
        term
        year
        name
      }
      loan{
        id
        loanType
        loanTypeName
        interestRate
        penaltyRate
        period
        paymentDue
        paymentDescription
        loanAmount
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        accruedPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        lastUpdate
        interestRateDetails{
          id
          seq
          interestDate
          interestRate
          penaltyRate
          remark
          status
        }
        loanDetails{
          id
          adjustment
          loanDetailType
          transaction{
            id
          }
          loanDate
          seq
          amount
        }
        loanDetailPlans{
          id
          seq
          loanDetailType
          loanDate
          amount
        }
        feeDetails{
          id
          adjustment
          transaction{
            id
          }
          feeType
          feeDate
          seq
          amount
          remark
          status
        }
        paymentRounds{
          id
          paymentRoundDate
          paymentRoundSeq
          paymentRoundType
          paymentRoundAmount
          paymentRoundInterestFixed
          paymentRoundInterest
          paymentRoundBalance
          paymentRoundRemark
        }
        payments{
          id
          adjustment
          transaction{
            id
          }
          paymentType
          receiveDate
          paymentDate
          paymentAmount
          paymentPrinciple
          paymentRemark
        }
      }
      educationStatus
      forecastDate
      graduationDate
      contractStatus
      restructuring
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
        remark
      }
      restructuringReference{
        id
      }
      status
    }
  }
`

export const DELETE_CONTRACT = gql`
  mutation deleteContract($id: ID!) {
    deleteContract(
      id: $id
    ) {
      id
    }
  }
`

export const FORCE_DELETE_CONTRACT = gql`
  mutation forceDeleteContract($id: ID!) {
    forceDeleteContract(
      id: $id
    ) {
      id
    }
  }
`

export const GET_RESTRUCTURING_DETAIL_BY_DATE = gql`
  query getRestructuringDetailByDate($id: ID!, $restructuringDate: String!) {
    getRestructuringDetailByDate(
      id: $id
      restructuringDate: $restructuringDate
    ) {
      restructuringFeeRemain
      restructuringPenaltyRemain
      restructuringInterestRemain
      restructuringPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      accruedPrincipleRemain
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      outstandingBalanceRestructuringRemain
      remark
    }
  }
`

export const GET_INTEREST_RATE_DETAIL = gql`
  query getInterestRateDetail($id: ID!) {
    getInterestRateDetail(
      id: $id
    ) {
      id
      loan{
        id
      }
      seq
      interestDate
      interestRate
      penaltyRate
      remark
      status
    }
  }
`

export const GET_INTEREST_RATE_DETAILS = gql`
  query getInterestRateDetails {
    getInterestRateDetails{
      id
      loan{
        id
      }
      seq
      interestDate
      interestRate
      penaltyRate
      remark
      status
    }
  }
`

export const CREATE_INTEREST_RATE_DETAIL = gql`
  mutation createInterestRateDetail($contractId: ID!, $payload: InterestRateDetailInput) {
    createInterestRateDetail(
      contractId: $contractId,
      payload: $payload
    ){
      id
      loan{
        id
      }
      seq
      interestDate
      interestType
      interestRate
      penaltyType
      penaltyRate
      debtCollectionFeeType
      debtCollectionFeeTypeName
      remark
      status
    }
  }
`

export const UPDATE_INTEREST_RATE_DETAIL = gql`
  mutation updateInterestRateDetail($id: ID!, $reCalculate: Boolean!, $payload: InterestRateDetailInput!) {
    updateInterestRateDetail(
      id: $id,
      reCalculate: $reCalculate,
      payload: $payload
    ) {
      id
      loan{
        id
      }
      seq
      interestDate
      interestRate
      penaltyRate
      remark
      status
    }
  }
`

export const DELETE_INTEREST_RATE_DETAIL = gql`
  mutation deleteInterestRateDetail($id: ID!) {
    deleteInterestRateDetail(
      id: $id
    ) {
      id
    }
  }
`

export const GET_LOAN_DETAIL = gql`
  query getLoanDetail($id: ID!) {
    getLoanDetail(
      id: $id
    ) {
      id
      adjustment
      loanDate
      seq
      amount
      remark
      status
    }
  }
`

export const GET_LOAN_DETAILS = gql`
  query getLoanDetails {
    getLoanDetails{
      id
      adjustment
      loanDate
      seq
      amount
      remark
      status
    }
  }
`

export const CREATE_LOAN_DETAIL = gql`
  mutation createLoanDetail($contractId: ID!, $payload: LoanDetailInput) {
    createLoanDetail(
      contractId: $contractId,
      payload: $payload
    ){
      id
      seq
      loanDetailType
      adjustment
      loanDate
      amount
      remark
      status
    }
  }
`

export const UPDATE_LOAN_DETAIL = gql`
  mutation updateLoanDetail($id: ID!, $reCalculate: Boolean!, $payload: LoanDetailInput!) {
    updateLoanDetail(
      id: $id,
      reCalculate: $reCalculate,
      payload: $payload
    ) {
      id
      adjustment
      loanDate
      seq
      amount
      remark
      status
    }
  }
`

export const DELETE_LOAN_DETAIL = gql`
  mutation deleteLoanDetail($id: ID!) {
    deleteLoanDetail(
      id: $id
    ) {
      id
    }
  }
`

export const GET_LOAN_DETAIL_PLAN = gql`
  query getLoanDetailPlan($id: ID!) {
    getLoanDetailPlan(
      id: $id
    ) {
      id
      loanDetailType
      loanDate
      seq
      amount
      remark
      status
    }
  }
`

export const GET_LOAN_DETAIL_PLANS_BY_CONTRACT_ID = gql`
  query getLoanDetailPlansByContractId($contractId: ID!) {
    getLoanDetailPlansByContractId(
      contractId: $contractId,
    ){
      id
      loanDetailType
      loanDate
      seq
      amount
      remark
      status
    }
  }
`

export const GET_LOAN_DETAIL_PLANS = gql`
  query getLoanDetailPlans {
    getLoanDetailPlans{
      id
      loanDetailType
      loanDate
      seq
      amount
      remark
      status
    }
  }
`

export const CREATE_LOAN_DETAIL_PLAN = gql`
  mutation createLoanDetailPlan($contractId: ID!, $payload: LoanDetailInput) {
    createLoanDetailPlan(
      contractId: $contractId,
      payload: $payload
    ){
      id
      loanDetailType
      loanDate
      seq
      amount
      remark
      status
    }
  }
`

export const UPDATE_LOAN_DETAIL_PLAN = gql`
  mutation updateLoanDetailPlan($id: ID!, $reCalculate: Boolean!, $payload: LoanDetailPlanInput!) {
    updateLoanDetailPlan(
      id: $id,
      reCalculate: $reCalculate,
      payload: $payload
    ) {
      id
      adjustment
      loanDate
      seq
      amount
      remark
      status
    }
  }
`

export const DELETE_LOAN_DETAIL_PLAN = gql`
  mutation deleteLoanDetailPlan($id: ID!) {
    deleteLoanDetailPlan(
      id: $id
    ) {
      id
    }
  }
`

export const GET_FEE_DETAIL = gql`
  query getFeeDetail($id: ID!) {
    getFeeDetail(
      id: $id
    ) {
      id
      adjustment
      transaction{
        id
      }
      feeType
      feeDate
      seq
      amount
      remark
      status
    }
  }
`

export const GET_FEE_DETAILS = gql`
  query getFeeDetails {
    getFeeDetails{
      id
      adjustment
      transaction{
        id
      }
      feeType
      feeDate
      seq
      amount
      remark
      status
    }
  }
`

export const CREATE_FEE_DETAIL = gql`
  mutation createFeeDetail($contractId: ID!, $payload: FeeDetailInput) {
    createFeeDetail(
      contractId: $contractId,
      payload: $payload
    ){
      id
      adjustment
      transaction{
        id
      }
      feeType
      feeDate
      seq
      amount
      remark
      status
    }
  }
`

export const RESET_FEE_DETAILS = gql`
  mutation resetFeeDetails($contractId: ID!) {
    resetFeeDetails(
      contractId: $contractId
    ){
      id
      adjustment
      transaction{
        id
      }
      feeType
      feeDate
      seq
      amount
      remark
      status
    }
  }
`

export const UPDATE_FEE_DETAIL = gql`
  mutation updateFeeDetail($id: ID!, $reCalculate: Boolean!, $payload: FeeDetailInput!) {
    updateFeeDetail(
      id: $id,
      reCalculate: $reCalculate,
      payload: $payload
    ) {
      id
      adjustment
      transaction{
        id
      }
      feeType
      feeDate
      seq
      amount
      remark
      status
    }
  }
`

export const DELETE_FEE_DETAIL = gql`
  mutation deleteFeeDetail($id: ID!) {
    deleteFeeDetail(
      id: $id
    ) {
      id
    }
  }
`

export const GET_PAYMENT_ROUND = gql`
  query getPaymentRound($id: ID!) {
    getPaymentRound(
      id: $id
    ) {
      id
      paymentRoundDate
      paymentRoundSeq
      paymentRoundType
      paymentRoundAmount
      paymentRoundInterestFixed
      paymentRoundInterest
      paymentRoundBalance
      paymentRoundRemark
      status
    }
  }
`

export const GET_PAYMENT_ROUNDS = gql`
  query getPaymentRounds {
    getPaymentRounds{
      id
      paymentRoundDate
      paymentRoundSeq
      paymentRoundType
      paymentRoundAmount
      paymentRoundInterestFixed
      paymentRoundInterest
      paymentRoundBalance
      paymentRoundRemark
      status
    }
  }
`

export const CREATE_PAYMENT_ROUND = gql`
  mutation createPaymentRound($contractId: ID!, $payload: PaymentRoundInput) {
    createPaymentRound(
      contractId: $contractId,
      payload: $payload
    ){
      id
      paymentRoundDate
      paymentRoundSeq
      paymentRoundType
      paymentRoundAmount
      paymentRoundInterestFixed
      paymentRoundInterest
      paymentRoundBalance
      paymentRoundRemark
      status
    }
  }
`

export const CREATE_PAYMENT_ROUNDS = gql`
  mutation createPaymentRounds($contractId: ID!, $payload: PaymentRoundsInput) {
    createPaymentRounds(
      contractId: $contractId,
      payload: $payload
    ){
      id
      paymentRoundDate
      paymentRoundSeq
      paymentRoundType
      paymentRoundAmount
      paymentRoundInterestFixed
      paymentRoundInterest
      paymentRoundBalance
      paymentRoundRemark
      paymentRoundExtra
      transactionCount
    }
  }
`

export const UPDATE_PAYMENT_ROUND = gql`
  mutation updatePaymentRound($id: ID!, $reCalculate: Boolean!, $payload: PaymentRoundInput!) {
    updatePaymentRound(
      id: $id,
      reCalculate: $reCalculate,
      payload: $payload
    ) {
      id
      paymentRoundDate
      paymentRoundSeq
      paymentRoundType
      paymentRoundAmount
      paymentRoundInterestFixed
      paymentRoundInterest
      paymentRoundBalance
      paymentRoundRemark
      status
    }
  }
`

export const DELETE_PAYMENT_ROUND = gql`
  mutation deletePaymentRound($id: ID!) {
    deletePaymentRound(
      id: $id
    ) {
      id
    }
  }
`

export const DELETE_PAYMENT_ROUNDS = gql`
  mutation deletePaymentRounds($id: ID!) {
    deletePaymentRounds(
      id: $id
    ) {
      count
    }
  }
`

export const GET_TRANSACTION = gql`
  query getTransaction($id: ID!) {
    getTransaction(
      id: $id
    ) {
      id
      paymentRound{
        id
        paymentRoundDate
        paymentRoundSeq
        paymentRoundType
        paymentRoundAmount
        paymentRoundInterestFixed
        paymentRoundInterest
        paymentRoundBalance
        paymentRoundRemark
        status
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
      }
      loanDetail{
        id
        loanDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        paymentType
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      principle
      balance
      outstandingBalance
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      paymentRoundAmount
      fee
      penaltyRate
      penalty
      interestRate
      interest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      status
    }
  }
`

export const GET_TRANSACTIONS = gql`
  query getTransactions {
    getTransactions{
      id
      paymentRound{
        id
        paymentRoundDate
        paymentRoundSeq
        paymentRoundType
        paymentRoundAmount
        paymentRoundInterestFixed
        paymentRoundInterest
        paymentRoundBalance
        paymentRoundRemark
        status
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
      }
      loanDetail{
        id
        loanDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        paymentType
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      principle
      balance
      outstandingBalance
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      paymentRoundAmount
      fee
      penaltyRate
      penalty
      interestRate
      interest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      status
    }
  }
`

export const GET_TRANSACTIONS_BY_CONTRACT_ID = gql`
  query getTransactionsByContractId($contractId: ID!) {
    getTransactionsByContractId(
      contractId: $contractId
    ){
      id
      paymentRound{
        id
        paymentRoundDate
        paymentRoundSeq
        paymentRoundType
        paymentRoundAmount
        paymentRoundInterestFixed
        paymentRoundInterest
        paymentRoundBalance
        paymentRoundRemark
        status
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
      }
      loanDetail{
        id
        adjustment
        loanDate
        seq
        amount
        remark
        status
      }
      feeDetail{
        id
        adjustment
        transaction{
          id
        }
        feeType
        feeDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        adjustment
        paymentType
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      restructuringFee
      restructuringPenalty
      restructuringInterest
      restructuringPrinciple
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      principle
      outstandingBalance
      outstandingBalanceRestructuring
      balance
      paymentRoundAmount
      fee
      penaltyRate
      penalty
      interestRate
      interest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      restructuringFeeRemain
      restructuringPenaltyRemain
      restructuringInterestRemain
      restructuringPrincipleRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      principleRemain
      outstandingBalanceRemain
      outstandingBalanceRestructuringRemain
      balanceRemain
      status
    }
  }
`

export const CREATE_TRANSACTION = gql`
  mutation createTransaction($contractId: ID!, $payload: TransactionInput) {
    createTransaction(
      contractId: $contractId,
      payload: $payload
    ){
      id
      paymentRound{
        id
        paymentRoundDate
        paymentRoundSeq
        paymentRoundType
        paymentRoundAmount
        paymentRoundInterestFixed
        paymentRoundInterest
        paymentRoundBalance
        paymentRoundRemark
        status
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
      }
      loanDetail{
        id
        loanDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        paymentType
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      principle
      balance
      outstandingBalance
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      paymentRoundAmount
      fee
      penaltyRate
      penalty
      interestRate
      interest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      status
    }
  }
`

export const CREATE_TRANSACTIONS = gql`
  mutation createTransactions($contractId: ID!, $payload: TransactionsInput) {
    createTransactions(
      contractId: $contractId,
      payload: $payload
    ){
      id
      paymentRound{
        id
        paymentRoundDate
        paymentRoundSeq
        paymentRoundType
        paymentRoundAmount
        paymentRoundInterestFixed
        paymentRoundInterest
        paymentRoundBalance
        paymentRoundRemark
        status
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
      }
      loanDetail{
        id
        loanDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        paymentType
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      principle
      balance
      outstandingBalance
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      paymentRoundAmount
      fee
      penaltyRate
      penalty
      interestRate
      interest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      status
    }
  }
`

export const UPDATE_TRANSACTION = gql`
  mutation updateTransaction($id: ID!, $reCalculate: Boolean!, $payload: TransactionInput!) {
    updateTransaction(
      id: $id,
      reCalculate: $reCalculate,
      payload: $payload
    ) {
      id
      paymentRound{
        id
        paymentRoundDate
        paymentRoundSeq
        paymentRoundType
        paymentRoundAmount
        paymentRoundInterestFixed
        paymentRoundInterest
        paymentRoundBalance
        paymentRoundRemark
        status
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
      }
      loanDetail{
        id
        loanDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        paymentType
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      principle
      balance
      outstandingBalance
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      paymentRoundAmount
      fee
      penaltyRate
      penalty
      interestRate
      interest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      status
    }
  }
`

export const DELETE_TRANSACTION = gql`
  mutation deleteTransaction($id: ID!) {
    deleteTransaction(
      id: $id
    ) {
      id
    }
  }
`

export const DELETE_TRANSACTIONS = gql`
  mutation deleteTransactions($id: ID!) {
    deleteTransactions(
      id: $id
    ) {
      count
    }
  }
`

export const RE_GENERATE_TRANSACTIONS = gql`
  mutation reGenerateTransactions($contractId: ID!, $updateToNow: Boolean!, $index: Int) {
    reGenerateTransactions(
      contractId: $contractId
      updateToNow: $updateToNow
      index: $index
    ){
      count
    }
  }
`

export const DELETE_TRANSACTIONS_BY_CONTRACT_ID_AND_TRANSACTION_DATE = gql`
  mutation deleteTransactionsByContractIdAndTransactionDate($contractId: ID!, $transactionDate: String!, $extra: Boolean!) {
    deleteTransactionsByContractIdAndTransactionDate(
      contractId: $contractId
      transactionDate: $transactionDate
      extra: $extra
    ){
      count
    }
  }
`

export const GET_TRANSACTION_EIR = gql`
  query getTransactionEir($id: ID!) {
    getTransactionEir(
      id: $id
    ) {
      id
      paymentRound{
        id
        paymentRoundDate
        paymentRoundSeq
        paymentRoundType
        paymentRoundAmount
        paymentRoundInterestFixed
        paymentRoundInterest
        paymentRoundBalance
        paymentRoundRemark
        status
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
      }
      loanDetail{
        id
        loanDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        paymentType
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      principle
      balance
      outstandingBalance
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      paymentRoundAmount
      fee
      penaltyRate
      penalty
      interestRate
      interest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      status
    }
  }
`

export const GET_TRANSACTION_EIRS = gql`
  query getTransactionEirs {
    getTransactionEirs{
      id
      paymentRound{
        id
        paymentRoundDate
        paymentRoundSeq
        paymentRoundType
        paymentRoundAmount
        paymentRoundInterestFixed
        paymentRoundInterest
        paymentRoundBalance
        paymentRoundRemark
        status
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
      }
      loanDetail{
        id
        loanDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        paymentType
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      principle
      balance
      outstandingBalance
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      paymentRoundAmount
      fee
      penaltyRate
      penalty
      interestRate
      interest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      status
    }
  }
`

export const GET_TRANSACTION_EIRS_BY_CONTRACT_ID = gql`
  query getTransactionEirsByContractId($contractId: ID!) {
    getTransactionEirsByContractId(
      contractId: $contractId
    ){
      id
      paymentRound{
        id
        paymentRoundDate
        paymentRoundSeq
        paymentRoundType
        paymentRoundAmount
        paymentRoundInterestFixed
        paymentRoundInterest
        paymentRoundBalance
        paymentRoundRemark
        status
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
      }
      loanDetail{
        id
        adjustment
        loanDate
        seq
        amount
        remark
        status
      }
      feeDetail{
        id
        adjustment
        transaction{
          id
        }
        feeType
        feeDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        adjustment
        paymentType
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      principle
      balance
      outstandingBalance
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      paymentRoundAmount
      fee
      penaltyRate
      penalty
      interestRate
      interest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      status
    }
  }
`

export const CREATE_TRANSACTION_EIR = gql`
  mutation createTransactionEir($contractId: ID!, $payload: TransactionEirInput) {
    createTransactionEir(
      contractId: $contractId,
      payload: $payload
    ){
      id
      paymentRound{
        id
        paymentRoundDate
        paymentRoundSeq
        paymentRoundType
        paymentRoundAmount
        paymentRoundInterestFixed
        paymentRoundInterest
        paymentRoundBalance
        paymentRoundRemark
        status
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
      }
      loanDetail{
        id
        loanDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        paymentType
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      principle
      balance
      outstandingBalance
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      paymentRoundAmount
      fee
      penaltyRate
      penalty
      interestRate
      interest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      status
    }
  }
`

export const CREATE_TRANSACTION_EIRS = gql`
  mutation createTransactionEirs($contractId: ID!, $payload: TransactionEirsInput) {
    createTransactionEirs(
      contractId: $contractId,
      payload: $payload
    ){
      id
      paymentRound{
        id
        paymentRoundDate
        paymentRoundSeq
        paymentRoundType
        paymentRoundAmount
        paymentRoundInterestFixed
        paymentRoundInterest
        paymentRoundBalance
        paymentRoundRemark
        status
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
      }
      loanDetail{
        id
        loanDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        paymentType
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      principle
      balance
      outstandingBalance
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      paymentRoundAmount
      fee
      penaltyRate
      penalty
      interestRate
      interest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      status
    }
  }
`

export const UPDATE_TRANSACTION_EIR = gql`
  mutation updateTransactionEir($id: ID!, $reCalculate: Boolean!, $payload: TransactionEirInput!) {
    updateTransactionEir(
      id: $id,
      reCalculate: $reCalculate,
      payload: $payload
    ) {
      id
      paymentRound{
        id
        paymentRoundDate
        paymentRoundSeq
        paymentRoundType
        paymentRoundAmount
        paymentRoundInterestFixed
        paymentRoundInterest
        paymentRoundBalance
        paymentRoundRemark
        status
      }
      restructuringDetail{
        id
        restructuringDate
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
      }
      loanDetail{
        id
        loanDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        paymentType
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      principle
      balance
      outstandingBalance
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      paymentRoundAmount
      fee
      penaltyRate
      penalty
      interestRate
      interest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      status
    }
  }
`

export const DELETE_TRANSACTION_EIR = gql`
  mutation deleteTransactionEir($id: ID!) {
    deleteTransactionEir(
      id: $id
    ) {
      id
    }
  }
`

export const DELETE_TRANSACTION_EIRS = gql`
  mutation deleteTransactionEirs($id: ID!) {
    deleteTransactionEirs(
      id: $id
    ) {
      count
    }
  }
`

export const RE_GENERATE_TRANSACTION_EIRS = gql`
  mutation reGenerateTransactionEirs($contractId: ID!, $updateToNow: Boolean!, $index: Int) {
    reGenerateTransactionEirs(
      contractId: $contractId
      updateToNow: $updateToNow
      index: $index
    ){
      count
    }
  }
`

export const DELETE_TRANSACTION_EIRS_BY_CONTRACT_ID_AND_TRANSACTION_DATE = gql`
  mutation deleteTransactionEirsByContractIdAndTransactionDate($contractId: ID!, $transactionDate: String!, $extra: Boolean!) {
    deleteTransactionEirsByContractIdAndTransactionDate(
      contractId: $contractId
      transactionDate: $transactionDate
      extra: $extra
    ){
      count
    }
  }
`

export const GET_PAYMENT = gql`
  query getPayment($id: ID!) {
    getPayment(
      id: $id
    ) {
      id
      loan{
        id
      }
      transaction{
        id
      }
      adjustment
      paymentType
      receiveDate
      paymentDate
      paymentAmount
      paymentPrinciple
      paymentRemark
      status
    }
  }
`

export const GET_PAYMENTS = gql`
  query getPayments {
    getPayments{
      id
      loan{
        id
      }
      transaction{
        id
      }
      adjustment
      paymentType
      receiveDate
      paymentDate
      paymentAmount
      paymentPrinciple
      paymentRemark
      status
    }
  }
`

export const GET_PAYMENTS_BY_CONTRACT_ID = gql`
  query getPaymentsByContractId($contractId: ID!, $date: String) {
    getPaymentsByContractId(
      contractId: $contractId,
      date: $date,
    ){
      id
      loan{
        id
      }
      transaction{
        id
        transactionDate
        paidAccruedFee
        paidAccruedPenalty
        paidAccruedInterest
        paidPrinciple
      }
      adjustment
      paymentType
      receiveDate
      paymentDate
      paymentAmount
      paymentPrinciple
      paymentRemark
      status
    }
  }
`

export const CREATE_PAYMENT = gql`
  mutation createPayment($contractId: ID!, $updateToNow: Boolean!, $payload: PaymentInput) {
    createPayment(
      contractId: $contractId,
      updateToNow: $updateToNow,
      payload: $payload
    ){
      id
      loan{
        id
      }
      transaction{
        id
      }
      adjustment
      paymentType
      receiveDate
      paymentDate
      paymentAmount
      paymentPrinciple
      paymentRemark
      status
    }
  }
`

export const CREATE_PAYMENT_TAX_AMOUNT = gql`
  mutation createPaymentTaxAmount($contractId: ID!) {
    createPaymentTaxAmount(
      contractId: $contractId
    ){
      id
    }
  }
`

export const CREATE_PAYMENT_CONTRACT_FEE = gql`
  mutation createPaymentContractFee($contractId: ID!) {
    createPaymentContractFee(
      contractId: $contractId
    ){
      id
    }
  }
`

export const CREATE_PAYMENTS = gql`
  mutation createPayments($contractId: ID!, $payload: PaymentsInput) {
    createPayments(
      contractId: $contractId,
      payload: $payload
    ){
      id
      loan{
        id
      }
      transaction{
        id
      }
      adjustment
      paymentType
      receiveDate
      paymentDate
      paymentAmount
      paymentPrinciple
      paymentRemark
      status
    }
  }
`

export const UPDATE_PAYMENT = gql`
  mutation updatePayment($id: ID!, $reCalculate: Boolean!, $payload: PaymentInput!) {
    updatePayment(
      id: $id,
      payload: $payload
    ) {
      id
      loan{
        id
      }
      transaction{
        id
      }
      adjustment
      paymentType
      receiveDate
      paymentDate
      paymentAmount
      paymentPrinciple
      paymentRemark
      status
    }
  }
`

export const DELETE_PAYMENTS_BY_CONTRACT_ID = gql`
  mutation deletePaymentsByContractId($contractId: ID!) {
    deletePaymentsByContractId(
      contractId: $contractId
    ) {
      count
    }
  }
`

export const DELETE_PAYMENT = gql`
  mutation deletePayment($id: ID!) {
    deletePayment(
      id: $id
    ) {
      id
    }
  }
`

export const DELETE_PAYMENTS = gql`
  mutation deletePayments($id: ID!) {
    deletePayments(
      id: $id
    ) {
      count
    }
  }
`

export const CREATE_RECEIPTS = gql`
  mutation createReceipts($payload: ReceiptsInput) {
    createReceipts(
      payload: $payload
    ){
      count
    }
  }
`

export const GET_FILE = gql`
  query getFile($id: ID!) {
    getFile(
      id: $id
    ){
      id
      seq
      contract{
        id
      }
      description
      fileName
      fileType
      pathUrl
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_FILES = gql`
  query getFiles {
    getFiles{
      id
      seq
      contract{
        id
      }
      description
      fileName
      fileType
      pathUrl
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const CREATE_FILE = gql`
  mutation createFile($payload: FileInput!) {
    createFile(
      payload: $payload
    ){
      id
      seq
      contract{
        id
      }
      description
      fileName
      fileType
      pathUrl
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_FILE = gql`
  mutation updateFile($id: ID!, $payload: FileInput!) {
    updateFile(
      id: $id
      payload: $payload
    ){
      id
      seq
      contract{
        id
      }
      description
      fileName
      fileType
      pathUrl
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_FILE_WITH_OUT_AUTH = gql`
  mutation updateFileWithOutAuth($id: ID!, $token: String!, $payload: FileInput!) {
    updateFileWithOutAuth(
      id: $id
      token: $token
      payload: $payload
    ){
      id
      seq
      contract{
        id
      }
      description
      fileName
      fileType
      pathUrl
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_FILE = gql`
  mutation deleteFile($id: ID!) {
    deleteFile(
      id: $id
    ) {
      id
    }
  }
`

// callHistory
export const CREATE_CALL_HISTORY = gql`
  mutation createCallHistory($contractId: ID!, $input: CallHistoryInput!) {
    createCallHistory(
      contractId: $contractId,
      input: $input
    ){
      id
      contract{
        id
      }
      seq
      callDate
      remark
      status
    }
  }
`

export const DELETE_CALL_HISTORY = gql`
  mutation deleteCallHistory($id: ID!) {
    deleteCallHistory(
      id: $id
    ) {
      id
    }
  }
`

export const CALL_HISTORIES_RECEIVED = gql`
  mutation callHistoriesReceived($contractId: ID!) {
    callHistoriesReceived(
      contractId: $contractId
    ) {
      id
      callHistoriesReceivedStatus
      callHistoriesReceivedAt
      callHistoriesReceivedBy{
        id
        prefix{
          id
          nameTh
        }
        name
        surname
        username
      }
    }
  }
`

export const CALL_HISTORIES_UN_RECEIVED = gql`
  mutation callHistoriesUnReceived($contractId: ID!) {
    callHistoriesUnReceived(
      contractId: $contractId
    ) {
      id
      callHistoriesReceivedStatus
      callHistoriesReceivedAt
      callHistoriesReceivedBy{
        id
        prefix{
          id
          nameTh
        }
        name
        surname
        username
      }
    }
  }
`

export const CALL_HISTORIES_UN_RECEIVED_BY_USER_ID = gql`
  mutation callHistoriesUnReceivedByUserId($userId:ID!) {
    callHistoriesUnReceivedByUserId(
      userId: $userId
    ) {
      count
    }
  }
`

export const CALL_HISTORIES_UN_RECEIVED_ALL = gql`
  mutation callHistoriesUnReceivedAll {
    callHistoriesUnReceivedAll{
      count
    }
  }
`

export const CALL_HISTORIES_RECEIVED_BY_IDS = gql`
  mutation callHistoriesReceivedByIds($userId:ID!, $ids: [ID!]!) {
    callHistoriesReceivedByIds(
      userId: $userId,
      ids: $ids
    ) {
      count
    }
  }
`
// sendSmsHistory
export const CREATE_SEND_SMS_HISTORY = gql`
  mutation createSendSmsHistory($contractId: ID!, $payload: SendSmsHistoryInput!) {
    createSendSmsHistory(
      contractId: $contractId,
      payload: $payload
    ){
      id
      contract{
        id
      }
      seq
      sendDate
      remark
      status
    }
  }
`

export const DELETE_SEND_SMS_HISTORY = gql`
  mutation deleteSendSmsHistory($id: ID!) {
    deleteSendSmsHistory(
      id: $id
    ) {
      id
    }
  }
`

// sendDocHistory
export const CREATE_SEND_DOC_HISTORY = gql`
  mutation createSendDocHistory($contractId: ID!, $payload: SendDocHistoryInput!) {
    createSendDocHistory(
      contractId: $contractId,
      payload: $payload
    ){
      id
      contract{
        id
      }
      seq
      sendDate
      remark
      status
    }
  }
`

export const DELETE_SEND_DOC_HISTORY = gql`
  mutation deleteSendDocHistory($id: ID!) {
    deleteSendDocHistory(
      id: $id
    ) {
      id
    }
  }
`

// lawsuitHistory
export const CREATE_LAW_SUIT_HISTORY = gql`
  mutation createLawsuitHistory($contractId: ID!, $payload: LawsuitHistoryInput!) {
    createLawsuitHistory(
      contractId: $contractId,
      payload: $payload
    ){
      id
      contract{
        id
      }
      seq
      lawsuitDate
      remark
      status
    }
  }
`

export const DELETE_LAW_SUIT_HISTORY = gql`
  mutation deleteLawsuitHistory($id: ID!) {
    deleteLawsuitHistory(
      id: $id
    ) {
      id
    }
  }
`

export const GET_DASHBOARD = gql`
  query getDashboard {
    getContractSummary {
      contractSummary
      contractAmount
      contractGroupByLoanTypes{
        id
        color
        loanType
        loanTypeName
        contractSummary
        contractAmount
        currentBalance
        currentBalanceCount
        currentOutstandingBalance
        currentOutstandingBalanceCount
        currentBillAmount
        currentBillAmountCount
        currentTotalBillAmount
        currentTotalBillAmountCount
        currentPaymentOutstandingBalance
        currentPaymentOutstandingBalanceCount
        currentPaymentBillAmount
        currentPaymentBillAmountCount
        currentPaymentTotalBillAmount
        currentPaymentTotalBillAmountCount
        currentPaymentOver
        currentPaymentOverCount
        currentBalanceRemain
        currentBalanceRemainCount
        currentOutstandingBalanceRemain
        currentOutstandingBalanceRemainCount
        currentBillAmountRemain
        currentBillAmountRemainCount
        currentTotalBillAmountRemain
        currentTotalBillAmountRemainCount
        paymentRoundTypeNone
        currentBalanceOverCurrentBillAmount
      }
    }
    getContractGroupByAgingWithOutLawsuit{
      no
      name
      contractSummary
    }
    getNewContract {
      contractSummary
    }
    getCloseContract {
      contractSummary
    }
  }
`

export const GET_CONTRACTS_BY_DASHBOARD_LIST = gql`
  query getContractsByDashboardList($payload: ContractFiltersInput) {
    getContractsByDashboardList(
      payload: $payload
    ){
      id
      contractLoanDate
      contractCloseDate
      forecastDate
      contractSeq
      contractNo
      contractName
      contractAmount
      contractStatus
      loan{
        id
        loanType
        loanTypeName
        loanAmount
        accruedPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        principleRemain
        outstandingBalanceRemain
        balanceRemain

        currentBalance
        currentOutstandingBalance
        currentBillAmount
        currentTotalBillAmount

        currentPaymentOutstandingBalance
        currentPaymentBillAmount
        currentPaymentTotalBillAmount

        currentPaymentOver

        currentBalanceRemain
        currentOutstandingBalanceRemain
        currentBillAmountRemain
        currentTotalBillAmountRemain

        agingDate
        agingNumber
      }
      borrower{
        project{
          id
          nameTh
        }
      }
      curriculum{
        id
        curriculumNo
        nameTh
      }
      callHistories{
        id
        seq
        callDate
        remark
        createdAt
        createdBy{
          id
          name
          surname
          prefix{
            nameTh
          }
        }
      }
      lawsuitHistories{
        id
        seq
        lawsuitDate
        remark
        createdAt
        createdBy{
          id
          name
          surname
          prefix{
            nameTh
          }
        }
      }
      educationStatus
      status
    }
  }
`

export const GET_CONTRACTS_BY_NOTIFICATION_LIST = gql`
  query getContractsByNotificationList($payload: ContractFiltersInput) {
    getContractsByNotificationList(
      payload: $payload
    ){
      id
      contractSeq
      contractNo
      contractName
      loan{
        id
        agingNumber
      }
      callHistories{
        id
        seq
        callDate
        remark
        createdAt
        createdBy{
          id
          name
          surname
          prefix{
            nameTh
          }
        }
      }
      lawsuitHistories{
        id
        seq
        lawsuitDate
        remark
        createdAt
        createdBy{
          id
          name
          surname
          prefix{
            nameTh
          }
        }
      }
      sendDocHistories{
        id
        seq
        sendDate
        remark
        createdAt
        createdBy{
          id
          name
          surname
          prefix{
            nameTh
          }
        }
      }
      sendSmsHistories{
        id
        seq
        sendDate
        remark
        createdAt
        createdBy{
          id
          name
          surname
          prefix{
            nameTh
          }
        }
      }
      status
    }
  }
`

export const GET_SURETY_DETAIL = gql`
  query getSuretyDetail($id: ID!) {
    getSuretyDetail(
      id: $id
    ){
      id
      seq
      relationshipId
      relationshipName
      appointmentDate
      appointmentRemark
      appointmentLatLong
      status
      appointmentLogs{
        id
        seq
        date
        remark
        createdAt
        createdBy{
          id
          fullName
        }
      }
      surety{
        id
        genderName
        fullName
        fullAddress
        idCardNumber
        birthDay
        issueDate
        expDate
        address{
          location
          houseNumber
          moo
          alley
          road
          subDistrict
          district
          province
          zipcode
        }
        mobile
        email
      }
    }
  }
`

export const GET_SURETY_DETAIL_WITH_OUT_AUTH = gql`
  query getSuretyDetailWithOutAuth($id: ID!, $token: String!) {
    getSuretyDetailWithOutAuth(
      id: $id,
      token: $token,
    ){
      id
      seq
      relationshipId
      relationshipName
      appointmentDate
      appointmentRemark
      appointmentLatLong
      status
      appointmentLogs{
        id
        seq
        date
        remark
        createdAt
        createdBy{
          id
          fullName
        }
      }
      surety{
        id
        genderName
        fullName
        fullAddress
        birthDay
        idCardNumber
        issueDate
        expDate
        address{
          location
          houseNumber
          moo
          alley
          road
          subDistrict
          district
          province
          zipcode
        }
        mobile
        email
        fileImageApproved{
          id
          description
          fileName
          fileType
          pathUrl
          status
          createdAt
          updatedAt
        }
        fileVideoApproved{
          id
          description
          fileName
          fileType
          pathUrl
          status
          createdAt
          updatedAt
        }
      }
      contract{
        id
        contractSeq
        contractNo
        contractName
        contractDate
        contractAmount
        contractAmountText
        smartAppStatus
        contractStatus
        verifyToken
        status
        borrower{
          id
          genderName
          fullName
          fullAddress
          birthDay
          idCardNumber
          studentCode
          issueDate
          expDate
          address{
            location
            houseNumber
            moo
            alley
            road
            subDistrict
            district
            province
            zipcode
          }
          phone
          mobile
          email
          fileImageApproved{
            id
            description
            fileName
            fileType
            pathUrl
            status
            createdAt
            updatedAt
          }
          fileVideoApproved{
            id
            description
            fileName
            fileType
            pathUrl
            status
            createdAt
            updatedAt
          }
        },
      }
    }
  }
`

export const GET_SURETY_DETAILS = gql`
  query getSuretyDetails {
    getSuretyDetails{
      id
      seq
      relationshipId
      relationshipName
      appointmentDate
      appointmentRemark
      appointmentLatLong
      status
      appointmentLogs{
        id
        seq
        date
        remark
        createdAt
        createdBy{
          id
          fullName
        }
      }
      surety{
        id
        genderName
        fullName
        fullAddress
        birthDay
        idCardNumber
        issueDate
        expDate
        address{
          location
          houseNumber
          moo
          alley
          road
          subDistrict
          district
          province
          zipcode
        }
        mobile
        email
      }
    }
  }
`

export const CREATE_SURETY_DETAIL = gql`
  mutation createSuretyDetail($payload: SuretyDetailInput!) {
    createSuretyDetail(
      payload: $payload
    ){
      id
      seq
      relationshipId
      relationshipName
      appointmentDate
      appointmentRemark
      appointmentLatLong
      status
      appointmentLogs{
        id
        seq
        date
        remark
        createdAt
        createdBy{
          id
          fullName
        }
      }
      surety{
        id
        genderName
        fullName
        fullAddress
        birthDay
        idCardNumber
        issueDate
        expDate
        address{
          location
          houseNumber
          moo
          alley
          road
          subDistrict
          district
          province
          zipcode
        }
        mobile
        email
      }
    }
  }
`

export const UPDATE_SURETY_DETAIL = gql`
  mutation updateSuretyDetail($id: ID!, $payload: SuretyDetailInput!) {
    updateSuretyDetail(
      id: $id
      payload: $payload
    ){
      id
      seq
      relationshipId
      relationshipName
      appointmentDate
      appointmentRemark
      appointmentLatLong
      status
      appointmentLogs{
        id
        seq
        date
        remark
        createdAt
        createdBy{
          id
          fullName
        }
      }
      surety{
        id
        genderName
        fullName
        fullAddress
        birthDay
        idCardNumber
        issueDate
        expDate
        address{
          location
          houseNumber
          moo
          alley
          road
          subDistrict
          district
          province
          zipcode
        }
        mobile
        email
      }
    }
  }
`

export const DELETE_SURETY_DETAIL = gql`
  mutation deleteSuretyDetail($id: ID!) {
    deleteSuretyDetail(
      id: $id
    ) {
      id
    }
  }
`

// contractids
export const CONTRACT_IDS_SIGN_IN_STUDENT_APP = gql`
  query contractIdsSignInStudentApp {
    contractIdsSignInStudentApp
  }
`

export const CREATE_QR_PAYMENT = gql`
  mutation createQrPayment($contractId: ID!, $payload: QrPaymentInput!) {
    createQrPayment(
      contractId: $contractId,
      payload: $payload,
    ) {
      taxId
      suffix
      ref1
      ref2

      paidFee
      paidPenalty
      paidInterest
      paidPrinciple
      balanceRemain

      paidContractFee
      paidTaxAmount
      paidProcessingFee
      paidCourtOrderExpense
      dueDate(local: true, format: "DD MMM YYYY HH:mm น.")
      amount
      createdAt
    }
  }
`
